export class MoleculePanelOverviewHeaderMultiDeleteDnsZoneActionComponent {
    public templateUrl = require('./multi-delete-dns-zone-action.html?external');
}
